import React, {
  ComponentType,
  FC,
  ReactElement,
  useEffect,
  useRef,
  useState,
} from "react";
import ReactDOM from "react-dom";
import YAML from "yaml";

import * as baja from "@nwebui/bajascript";

import { loadPx } from "./loader";
import { PxViewContext, PxViewContextValue } from "./PxViewContext";
import render from "./render";
import { WidgetProps } from "./widgets/Widget";

export type WidgetFactory = (
  widget: baja.Component,
) => ComponentType<WidgetProps> | void;

const PxView: FC<{
  url: string;
  factory?: WidgetFactory;
  context: PxViewContextValue;
}> = function ({ url, factory, context }) {
  const [elem, setElem] = useState<ReactElement | null>(null);
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    async function load() {
      const px = await loadPx(url);
      const elem = render(px, factory);
      setElem(elem);
    }
    load();
  }, [url]);

  return (
    <div ref={divRef} style={{ width: "100%", height: "100%" }}>
      <PxViewContext.Provider value={context}>{elem}</PxViewContext.Provider>
    </div>
  );
};

export default PxView;

export function customizedLabelFactory(widgets: {
  [type: string]: ComponentType<WidgetProps>;
}): WidgetFactory {
  return (widget) => {
    if (widget.is("bajaui:Label")) {
      const text = widget.gets("text") ?? "";
      if (text.match(/^type:/)) {
        const args = YAML.parse(text);
        return widgets[args.type];
      }
    }
    return;
  };
}
